import { jsxs, jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import IChangeAddress from "../resources/ChangeAddress.png.js";
import IChangeDate from "../resources/ChangeDate.png.js";
import INeighbour from "../resources/Neighbour.png.js";
import IPickupShop from "../resources/PickupShop.png.js";
import IPrecise from "../resources/Precise.png.js";
import ISafePlace from "../resources/SafePlace.png.js";
import IUpgrade from "../resources/Upgrade.png.js";
import ICollectFromDepot from "../resources/CollectFromDepot.png.js";
const iconMap = {
  ONE: IPrecise,
  PKU: IPickupShop,
  ALA: IChangeAddress,
  RED: IChangeDate,
  SFP: ISafePlace,
  DTN: INeighbour,
  UPG: IUpgrade,
  TBC: ICollectFromDepot
};
const SuggestionSquare = (props) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: props.className + " suggestion-square",
      onClick: props.onClick,
      children: [
        /* @__PURE__ */ jsx("img", { alt: "Suggestion Description", src: iconMap[props.option.icon] }),
        /* @__PURE__ */ jsx("label", { children: props.option.title })
      ]
    }
  );
};
SuggestionSquare.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  option: PropTypes.object
};
export {
  SuggestionSquare as default
};
//# sourceMappingURL=SuggestionSquare.js.map
